module.exports = __webpack_public_path__ + "img/activecampaign.24dec2a7.png";